import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch } from '@btime/react-contexts'
import React from 'react'

import { compliancesClient } from '../../../../../utils/apollo/api'
import { getQueryParam } from '../../../../../utils/helpers/url'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../components/helpers/StatePresenter'
import { convertFilterToRelativeDates } from '../../../../../utils/helpers/date'

const Context = React.createContext([])
const { Provider } = Context
export const useNonCompliancesState = () => React.useContext(Context)
export const useNonCompliances = () => useNonCompliancesState()?.nonCompliances

const QUERY = gql`
  query NonCompliances($page: Int, $search: String, $filter: NonComplianceFilter) {
    nonCompliances(page: $page, search: $search, sort: { field: UPDATED_AT, type: DESC }, filter: $filter) {
      id
      place {
        id
        name
      }
      question {
        id
        name
        checklist {
          id
          name
        }
        category {
          id
          name
        }
      }
      actionPlansCount
      finishedActionPlansCount
      instancesCount
      status
      insertedAt
      updatedAt
      endDate
    }
  }
`

const NonCompliancesLoader = ({ children, uncontrolledChildren, placeId }) => {
  const search = useSearch()
  let filter = useCleanFilterForRequest()
  filter = convertFilterToRelativeDates(filter)

  const origin = getQueryParam('origin') || 'serviceOrder'

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      limit: 100,
      search,
      filter: { ...filter, origins: origin, placeIds: placeId }
    },
    client: compliancesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default NonCompliancesLoader
